const root = document.documentElement
const path = window.location.pathname.toLowerCase()
const isTrailPage = root.classList.contains('dk-itinerario-escursione')
const isEventPage =
  root.classList.contains('dk-evento') || /\/eventi\/art_[^/]+\/?$/.test(path)
const isPrintableArticle =
  root.classList.contains('dk-printable-article') || isTrailPage || isEventPage

if (isPrintableArticle) {
  root.classList.add('dk-printable-article')

  if (isEventPage) {
    root.classList.add('dk-evento')
  }

  const article = document.querySelector('#content.article')
  const originalLogo = document.querySelector('.lo .logo-cnt img')
  const sectionTitle =
    document.querySelector('.lo .titoli-cnt h1')?.textContent.trim() ||
    (isEventPage ? 'Eventi' : 'Itinerari escursioni e passeggiate')

  const menuId = Number(window.WC?.idMenu)
  const printPageClass = isEventPage
    ? 'dk-print-page-eventi'
    : menuId === 80
      ? 'dk-print-page-mtb'
      : menuId === 120
        ? 'dk-print-page-orienteering'
        : 'dk-print-page-escursioni'

  root.classList.add(printPageClass)

  if (!article) {
    // La pagina non ha la struttura articolo prevista.
  } else {
    const coverImage = isTrailPage
      ? article.querySelector(':scope > .fotoDidascaliaSx')
      : article.querySelector(
          ':scope > .fotoDidascaliaSx, :scope > a:first-of-type, :scope > .image'
        )

    coverImage?.classList.add('article-print-cover')

    if (isTrailPage) {
      coverImage?.classList.add('trail-print-cover')
    }

    function clonePrintLogo(className) {
      const logo = originalLogo?.cloneNode(true) || document.createElement('img')

      if (!originalLogo) {
        logo.src = '/images/css/logo.svg'
        logo.alt = 'Asiago.it'
      }

      logo.removeAttribute('width')
      logo.removeAttribute('height')
      logo.className = className

      return logo
    }

    const printHeader = document.createElement('header')
    printHeader.className = 'article-print-header'

    const printHeaderMeta = document.createElement('div')
    printHeaderMeta.className = 'article-print-header__meta'

    const printHeaderTitle = document.createElement('strong')
    printHeaderTitle.textContent = sectionTitle

    const printUrl = document.createElement('span')
    printUrl.textContent = window.location.href.split('#')[0]

    printHeaderMeta.append(printHeaderTitle, printUrl)
    printHeader.append(
      clonePrintLogo('article-print-header__logo'),
      printHeaderMeta
    )

    /*
     * La testata va inserita nel contenuto dell'articolo.
     * Sulle pagine eventi la prima .section non coincide sempre
     * con il contenitore dell'articolo e poteva quindi nasconderla.
     */
    article.prepend(printHeader)

    function syncPrintBannerVisibility() {
      for (const box of document.querySelectorAll('.boxPub')) {
        const hasOwnBanner = Array.from(box.querySelectorAll('.bannerright')).some(
          banner =>
            banner.querySelector('img, iframe, a, object, embed') ||
            banner.textContent.trim().length > 0
        )

        box.classList.toggle('boxPub--print-visible', hasOwnBanner)
      }
    }

    let isPrintMode = false
    const readmorePrintState = []
    let detachedTrailStatus = null
    let printSidebarState = null
    let printAdvertisersState = null

    function expandReadmoresForPrint() {
      if (!isTrailPage || readmorePrintState.length > 0) {
        return
      }

      const toggles = Array.from(document.querySelectorAll('[data-readmore-toggle]'))

      for (const content of document.querySelectorAll('.trailStatus [data-readmore]')) {
        const toggle = toggles.find(
          element => element.getAttribute('data-readmore-toggle') === content.id
        )

        readmorePrintState.push({
          content,
          contentStyle: content.getAttribute('style'),
          ariaExpanded: content.getAttribute('aria-expanded'),
          toggle,
          toggleStyle: toggle?.getAttribute('style') ?? null,
        })

        content.style.setProperty('height', 'auto', 'important')
        content.style.setProperty('max-height', 'none', 'important')
        content.style.setProperty('overflow', 'visible', 'important')
        content.setAttribute('aria-expanded', 'true')

        toggle?.style.setProperty('display', 'none', 'important')
      }
    }

    function restoreReadmoresAfterPrint() {
      for (const state of readmorePrintState) {
        if (state.contentStyle === null) {
          state.content.removeAttribute('style')
        } else {
          state.content.setAttribute('style', state.contentStyle)
        }

        if (state.ariaExpanded === null) {
          state.content.removeAttribute('aria-expanded')
        } else {
          state.content.setAttribute('aria-expanded', state.ariaExpanded)
        }

        if (state.toggle) {
          if (state.toggleStyle === null) {
            state.toggle.removeAttribute('style')
          } else {
            state.toggle.setAttribute('style', state.toggleStyle)
          }
        }
      }

      readmorePrintState.length = 0
    }

    function normalizeTechnicalBoxForPrint() {
      if (!isTrailPage) {
        return
      }

      const technicalBox = article.querySelector('.escursioni')
      const trailStatus = article.querySelector('.trailStatus')

      if (
        !technicalBox ||
        !trailStatus ||
        technicalBox.contains(trailStatus) ||
        detachedTrailStatus
      ) {
        return
      }

      const placeholder = document.createComment('trail-status-print-position')

      trailStatus.parentNode?.insertBefore(placeholder, trailStatus)
      technicalBox.append(trailStatus)

      detachedTrailStatus = {
        trailStatus,
        placeholder,
      }
    }

    function restoreTechnicalBoxAfterPrint() {
      if (!detachedTrailStatus) {
        return
      }

      detachedTrailStatus.placeholder.replaceWith(detachedTrailStatus.trailStatus)
      detachedTrailStatus = null
    }

    function buildPrintSidebar() {
      if (!isTrailPage || printSidebarState) {
        return
      }

      const technicalBox = article.querySelector('.escursioni')

      if (!technicalBox) {
        return
      }

      const placeholder = document.createComment('trail-technical-print-position')

      technicalBox.before(placeholder)

      const sidebar = document.createElement('aside')
      sidebar.className = 'trail-print-sidebar'

      placeholder.after(sidebar)
      sidebar.append(technicalBox)

      printSidebarState = {
        sidebar,
        technicalBox,
        placeholder,
      }
    }

    function restorePrintSidebar() {
      if (!printSidebarState) {
        return
      }

      const {sidebar, technicalBox, placeholder} = printSidebarState

      placeholder.replaceWith(technicalBox)
      sidebar.remove()

      printSidebarState = null
    }

    function moveAdvertiserBoxesForPrint() {
      if (!isTrailPage || printAdvertisersState) {
        return
      }

      const advertiserBoxes = Array.from(
        article.querySelectorAll('.minisite-article-links')
      )

      if (advertiserBoxes.length === 0) {
        return
      }

      const entries = advertiserBoxes.map(advertiserBox => {
        const placeholder = document.createComment(
          'trail-advertiser-print-position'
        )

        advertiserBox.before(placeholder)

        return {
          advertiserBox,
          placeholder,
        }
      })

      const container = document.createElement('section')
      container.className = 'trail-print-advertisers'

      for (const {advertiserBox} of entries) {
        container.append(advertiserBox)
      }

      /*
       * Negli articoli legacy tutto il contenuto dell'itinerario può essere
       * racchiuso dentro .dk-itinerario-escursione.
       *
       * Il contenitore CNTASS deve quindi essere inserito direttamente
       * prima della mappa/grafico, senza risalire fino al figlio di #content.
       */
      const trailContent =
        article.querySelector(':scope > .dk-itinerario-escursione') || article

      const boundary = trailContent.querySelector(
        '.iframe-container-trailmap, .iframe-container-trailquote, .gallery-cnt, .syfb'
      )

      if (boundary) {
        boundary.before(container)
      } else {
        trailContent.append(container)
      }

      printAdvertisersState = {
        container,
        entries,
      }
    }

    function restoreAdvertiserBoxesAfterPrint() {
      if (!printAdvertisersState) {
        return
      }

      for (const {advertiserBox, placeholder} of printAdvertisersState.entries) {
        placeholder.replaceWith(advertiserBox)
      }

      printAdvertisersState.container.remove()
      printAdvertisersState = null
    }

    function prepareArticleContentForPrint() {
      if (isTrailPage) {
        normalizeTechnicalBoxForPrint()
        expandReadmoresForPrint()
        buildPrintSidebar()
        moveAdvertiserBoxesForPrint()
      }
    }

    function restoreArticleContentAfterPrint() {
      if (isTrailPage) {
        restoreAdvertiserBoxesAfterPrint()
        restorePrintSidebar()
        restoreReadmoresAfterPrint()
        restoreTechnicalBoxAfterPrint()
      }
    }

    function syncTrailIframePrintStyles() {
      if (!isTrailPage) {
        return
      }

      const iframes = document.querySelectorAll(
        '.iframe-container-trailmap iframe, .iframe-container-trailquote iframe'
      )

      for (const iframe of iframes) {
        let iframeDocument

        try {
          iframeDocument = iframe.contentDocument
        } catch {
          continue
        }

        if (!iframeDocument?.head) {
          continue
        }

        const currentStyle = iframeDocument.getElementById(
          'trail-iframe-print-style'
        )

        if (!isPrintMode) {
          currentStyle?.remove()
          continue
        }

        if (currentStyle) {
          continue
        }

        const style = iframeDocument.createElement('style')
        style.id = 'trail-iframe-print-style'
        style.textContent = `
          html,
          body {
            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;
            height: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
          }

          body > *,
          #gmap_div,
          canvas,
          svg,
          img {
            max-width: 100% !important;
          }

          #gmap_div {
            width: 100% !important;
            height: 100% !important;
          }

          canvas,
          svg,
          img {
            height: auto !important;
          }
        `

        iframeDocument.head.append(style)
      }
    }

    for (const iframe of document.querySelectorAll(
      '.iframe-container-trailmap iframe, .iframe-container-trailquote iframe'
    )) {
      iframe.addEventListener('load', syncTrailIframePrintStyles)
    }

    const googlePrintArtifacts = new Set()

    function markGooglePrintArtifacts() {
      const selectors = [
        'ins.adsbygoogle',
        '.adsbygoogle-noablate',
        '.google-auto-placed',
        '[data-anchor-status]',
        '[data-anchor-shown]',
        '.grippy-host',
        '[class*="grippy-host"]',
        '[data-google-query-id]',
        '[id^="aswift_"]',
        '[id^="google_ads_iframe_"]',
        'iframe[title="Advertisement"]',
        'iframe[src*="googleads"]',
        'iframe[src*="doubleclick"]',
      ].join(',')

      for (const element of document.querySelectorAll(selectors)) {
        let target = element

        for (
          let current = element;
          current && current !== document.body;
          current = current.parentElement
        ) {
          const position = window.getComputedStyle(current).position
          const className =
            typeof current.className === 'string' ? current.className : ''
          const marker = `${current.id} ${className}`

          if (
            position === 'fixed' ||
            position === 'sticky' ||
            /anchor|side.?rail|grippy/i.test(marker)
          ) {
            target = current
          }

          if (position === 'fixed' || position === 'sticky') {
            break
          }
        }

        target.classList.add('article-print-google-artifact')
        googlePrintArtifacts.add(target)
      }
    }

    function clearGooglePrintArtifacts() {
      for (const element of googlePrintArtifacts) {
        element.classList.remove('article-print-google-artifact')
      }

      googlePrintArtifacts.clear()
    }

    syncPrintBannerVisibility()

    window.addEventListener('beforeprint', () => {
      isPrintMode = true
      prepareArticleContentForPrint()
      markGooglePrintArtifacts()
      syncPrintBannerVisibility()
      syncTrailIframePrintStyles()
    })

    window.addEventListener('afterprint', () => {
      isPrintMode = false
      restoreArticleContentAfterPrint()
      clearGooglePrintArtifacts()
      syncTrailIframePrintStyles()
    })

    function openPrintPreview() {
      prepareArticleContentForPrint()
      markGooglePrintArtifacts()

      requestAnimationFrame(() => {
        window.print()
      })
    }

    const button = document.createElement('button')

    button.type = 'button'
    button.className = 'article-print-button'
    button.innerHTML = `
      <span class="material-icons article-print-button__icon" aria-hidden="true">print</span>
      <span>${isEventPage ? 'Stampa evento' : 'Stampa itinerario'}</span>
    `

    button.addEventListener('click', openPrintPreview)

    const shareContainer = document.querySelector('.share')
    const facebookShare = shareContainer?.querySelector('.share--facebook')

    if (shareContainer && facebookShare) {
      const actionsContainer = document.createElement('div')
      actionsContainer.className = 'article-print-actions'

      facebookShare.insertAdjacentElement('beforebegin', actionsContainer)
      actionsContainer.append(facebookShare, button)
    } else {
      const insertionPoint =
        article.querySelector('.gallery-cnt') ||
        article.querySelector('.syfb') ||
        article

      insertionPoint.insertAdjacentElement('afterend', button)
    }
  }
}
